module.exports = "<div class=\"register\">\n  <h4>Not found</h4>\n</div>\n"